import { Component, Input, OnInit } from '@angular/core';
import { JobService } from '../../../../../../../UI/src/app/shared/job/job.service';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { TranslateService } from '@ngx-translate/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { CandidateProfileComponent } from '../../../candidate-profile/candidate-profile.component';
import { JobSearchComponent } from '../../job-search.component';
import * as _ from 'lodash';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';
import * as moment from 'moment/moment';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { TranslationLoaderService } from '../../../../../../../UI/src/app/shared/translation/translation-loader.service';
import { JobDetailsPage } from '../../../job-search/components/job-details/job-details.component';
@Component({
  selector: 'sts-job-assessment',
  templateUrl: './job-assessment.component.html'
})
export class JobAssessmentComponent implements OnInit {
  requisitionAssessmentData: any;
  alertData: any = null;
  loading = false;
  isChecked = false;
  isAllCheckboxValid = true;
  hideActions = false;
  searchTranslations: any;
  completion = 0;
  applicationId = 0;
  phaseassessmentId =0;
  fromTimeLine = false;
  navigatedFrom = '';
  isWelcomePage = true;
  isAssessment = false;
  isDrafted= false;
  isSelfAssessment= false;
  tempQuestion:any;
  hourValues: any;
  @Input() choices: any;
  @Input() assessmentId;
  pagedView = {
    itemsPerPage: [],
    availablePages: [],
    availablePages_v2: {},
    currentPage: null,
    currentPageNumber: 0,
    totalCount: 0,
    isSelfAssessment: false,
    nextPage: function (pagedItems: any) {
      this.currentPageNumber++;
      this.isSelfAssessment = pagedItems[this.currentPageNumber].isSelfAssessment;
      setTimeout(() => {
        this.maintainFocusOnPageChange();
      }, 100);
    },
    previousPage: function (pagedItems: any) {
      this.currentPageNumber--;
      this.isSelfAssessment = pagedItems[this.currentPageNumber].isSelfAssessment;
      setTimeout(() => {
        this.maintainFocusOnPageChange();
      }, 100);
    },
    totalQuestionsCount: 0,
    previousQuestionNumber: 0,
    maintainFocusOnPageChange: function () {
      const pageName = document.getElementById('page-name');
      if (pageName) {
        pageName.focus();
      } else {
        const pageHeading = document.getElementById('page-heading');
        if (pageHeading) {
          pageHeading.focus();
        } else {
          const firstElementInContent = <HTMLElement>document.querySelector('.first-focusable-element');
          if (firstElementInContent) {
            firstElementInContent.focus();
          } else {
            document.getElementById('closeButton').focus();
          }
        }
      }
    }
  };

  previousQuestionNumber = 0;
  pagedItems: any = {};
  requisitionId = 0;

  constructor(
    private profileService: ProfileService,
    private translate: TranslateService,
    public navCtrl: NavController,
    private navParams: NavParams,
    private toastService: ToastControllerService,
    public events: Events,
    private jobService: JobService,
    private authenticationService: AuthenticationService,
    private resumeService: ResumeService,
    private translationLoader: TranslationLoaderService
  ) {
      this.isAssessment = navParams.get("isAssessment");
      this.isSelfAssessment = navParams.get("isSelfAssessment");
      if(this.isAssessment == true){
        this.assessmentId = navParams.get("assessmentId");
        this.applicationId = navParams.get("applicationId");
        this.navigatedFrom = navParams.get("navigatedFrom");
        this.requisitionId = navParams.get("jobId");
      }
      else
        this.requisitionId = navParams.get("jobId");
      this.navigatedFrom = navParams.get("navigatedFrom");
      this.applicationId = navParams.get("applicationId");
      this.isDrafted = navParams.get("isDrafted");
    }

  ngOnInit() {
    this.translate.get(['CAREER_APPLIED_SUCCESS',
        'CAREER_ALREADY_APPLIED',
        'CAREER_FAILED_MESSAGE',
        'CAREER_ASSESSMENT_SAVED',
       'CAREER_APPLY_INCOMPLETE_SUCCESS'
      ]).subscribe((obj) => {
        this.searchTranslations = obj;
      });

  const jobObject = this.jobService.getApplyJobObject();
  this.applicationId = this.applicationId !== 0  ? this.applicationId:  jobObject !== undefined ? jobObject.ApplicationId : null;
  this.getAssessmentId();
}

  getJobAssessmentWithAnswers() {
    this.loading = true;
    this.jobService.getAssessmentWithAnswers(this.assessmentId, this.applicationId).subscribe(
      (response) => {
       this.setQuestions(response);
      }, (error) => {
        this.loading = false;
        this.alertData = { message: this.searchTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
      }
    );
  }

  getAssessmentId() {

    this.loading = true;
    if(this.isAssessment == true && this.navigatedFrom == "timeline" ){
      this.fromTimeLine = true;
      this.getTimelineAssessmentDetails();
    }
    else if(this.isAssessment == true){
      this.getJobAssessmentDetails();
    }
    else if(this.isAssessment == false && this.isSelfAssessment == true)
    {
      this.assessmentId=0;
      this.getSelfAssessmentForRequisition();

    }
    else{
      this.jobService.getAssessmentIdForRequisition(this.requisitionId)
      .subscribe((response) => {
        this.loading = false;
        this.assessmentId = response != null ? response : 0;
        if(this.assessmentId > 0 && this.isDrafted && this.applicationId) {
          this.getJobAssessmentWithAnswers();
        }
        else if (this.assessmentId > 0) {
           this.getJobAssessmentDetails();
        } else {
          this.getSelfAssessmentForRequisition();
        }
      }, (error) => {
        this.loading = false;
        this.toastService.presentToast({ message: this.searchTranslations.CAREER_FAILED_MESSAGE, type: 'error' });
      });
    }
  }

  cancelApply() {
    this.navCtrl.pop();
  }

  private filterItemsBySite(items) {
    // retain only external site questions
    return _.filter(items, function (item) {
      if (item.question) {
        return item.question.siteCode !== '1';
      } else {
        return true;
      }
    });
  }

  getJobAssessmentDetails() {
    this.loading = true;
    this.jobService.getAssessment(this.assessmentId).subscribe(
      (response) => {
        this.setQuestions(response);
      }, (error) => {
        this.loading = false;
        this.toastService.presentToast({ message: this.searchTranslations.CAREER_FAILED_MESSAGE, type: 'error' });
  }
    );
  }

  getTimelineAssessmentDetails() {
    this.loading = true;
    this.jobService.getCandidateAssessment(this.assessmentId).subscribe(
      (response) => {
       this.applicationId = response.applicationId;
       this.assessmentId = response.requisitionAssessmentId;
       this.phaseassessmentId= response.phaseAssessmentId;
       this.setQuestions(response)
      }, (error) => {
        this.loading = false;
        this.toastService.presentToast({ message: this.searchTranslations.CAREER_FAILED_MESSAGE, type: 'error' });
  }
    );
  }
  monthShortNames:any;
  public getDateTimeFormat(item) {
    var culture = Storage.ENGLISH_CULTURE;
    const token = window.localStorage.getItem(Storage.AUTH_TOKEN);
    if (token && token !== 'null') {
       culture =  this.translationLoader.getCurrentCulture();;
    } else {
      const preferredCulture = window.localStorage.getItem(Storage.CULTURE);
      if (preferredCulture) {
        culture = preferredCulture;
       }
    }
    var dateFormatStr = moment.localeData(culture).longDateFormat('L');
    this.monthShortNames = moment.localeData(culture).monthsShort();
    return dateFormatStr;

  }

  private setQuestionAnswers(question: any) {
    if (question.childQuestions.length === 0) {
      let emptyAnswer = null;
      if (question.typeCode === '-2' || question.typeCode === '3') {
        emptyAnswer = '';
      }
      if (!question.assessmentAnswer) {
        question.assessmentAnswer = {
          answer:emptyAnswer,
          questionId:question.id,
          applicationId: this.applicationId,
          assessingPersonId: 0,
          assessmentId: this.assessmentId,
          phaseAssessmentId:this.phaseassessmentId,
          interviewId: null
        };
      }

      if (question.typeCode === '4' && question.assessmentAnswer != null && question.assessmentAnswer.answer != null) {
        _.each(question.questionAnswerChoice, function (choice) {
          if (question.assessmentAnswer.answer.split(',').indexOf(choice.choiceText) !== -1) {
            choice.checked = true;
          }
        });
      }
    } else {
      for (const childQuestion of question.childQuestions) {
        this.setQuestionAnswers(childQuestion);
      }
    }
  }

  private arrangeItemsByPage(assessment: any, assessmentsItems: any[], selfAssessmentItems: any[]) {
    // Check for welcome page.
    if (this.requisitionAssessmentData.recruitingAssessment.showWelcomeScreen) {
      this.pagedView.totalCount++;
      this.pagedView.availablePages.push('WelcomePage');
      this.pagedItems[0] = { name: 'Introduction', number: 0, questions: null };
      this.isWelcomePage = true;
    } else {
      this.isWelcomePage = false;
    }
    if ((this.requisitionAssessmentData.recruitingAssessment.items == null && this.isSelfAssessment) || this.requisitionAssessmentData.recruitingAssessment.items.length > 0 || !this.assessmentId) {
    this.setPageObject(assessmentsItems, selfAssessmentItems);
    }

    // check for completion page
    if (this.requisitionAssessmentData.recruitingAssessment.showCompletionScreen) {
      this.pagedView.totalCount++;
      this.pagedView.availablePages.push('CompletionPage');
      this.pagedItems[this.pagedView.totalCount - 1] = { name: 'Final Submission', number: this.pagedView.totalCount - 1, questions: null };
    }
  }

  private setPageObject(assessmentItems: any[], selfAssessmentItems: any[]): any {
       assessmentItems = assessmentItems ?  assessmentItems : [];
       var pageItems = assessmentItems.filter(item => item.itemType === 0);

    let selAssessmentsPageNumbers = selfAssessmentItems.map(item => item.page).filter((value, index, self) => self.indexOf(value) === index);
    selAssessmentsPageNumbers.forEach((pageNumber) =>
      {
        let currentSelfAssessmentPage = selfAssessmentItems.filter(item => item.page === pageNumber && item.itemType === 0)[0];
        currentSelfAssessmentPage.isSelfAssessment = true;
        pageItems = pageItems.concat(currentSelfAssessmentPage);
      }
    );

    assessmentItems = assessmentItems.concat(selfAssessmentItems);

    this.pagedView.totalCount += pageItems.length;
    for (const pageItem of pageItems) {
      let page_num = pageItem.page;
      if (!this.isWelcomePage) {
        page_num = page_num - 1;
      }
      this.pagedItems[page_num] = { name: pageItem.itemText, isSelfAssessment: pageItem.isSelfAssessment, number: page_num, questions: null };
      this.pagedItems[page_num].questions = assessmentItems.filter(
        assessmentItem => assessmentItem.page === pageItem.page && (assessmentItem.itemType === 4 || assessmentItem.itemType === 6 || assessmentItem.itemType === 0)
      );


      for (const question of this.pagedItems[page_num].questions) {
        if (question.itemType === 4) {
          question.questionNumber = ++this.previousQuestionNumber;
        }
      }

      this.pagedView.totalQuestionsCount += assessmentItems.filter(
        assessmentItem => assessmentItem.page === pageItem.page && assessmentItem.itemType === 4
      ).length;
    }

    this.getMinMaxOfRatingMatrix(this.pagedItems);
  }

  updateCheckBoxQuestionAnswer (answerObject: any, checkboxValue: any , choiceText: any) {
    if (answerObject.answer) {
      const selectedOptionsArray = answerObject.answer.split(',');

      if (checkboxValue) {
        selectedOptionsArray.push(choiceText);
      } else {
        const optionIndex = selectedOptionsArray.indexOf(choiceText);
        if (optionIndex !== -1) {
          selectedOptionsArray.splice(optionIndex, 1);
        }
      }

      answerObject.answer = selectedOptionsArray.join();

    } else {
      answerObject.answer = choiceText;
    }
  }

  extractAnswersFromQuestion(question) {
    const answersList = [];
    function getRecursively(questions, application) {
      if (questions.childQuestions.length === 0) {
        if (questions.assessmentAnswer) {
          if (questions.questionAnswerChoice != null && questions.questionAnswerChoice.length > 0) {
            const selectedOption = _.filter(questions.questionAnswerChoice, { id: questions.assessmentAnswer.answerChoiceId });
            if (selectedOption.length === 1) {
              questions.assessmentAnswer.answer = selectedOption[0].choiceText;
              questions.assessmentAnswer.answerChoiceId = selectedOption[0].id;
            }
          } else {
            questions.assessmentAnswer.answer = questions.assessmentAnswer.answer ? questions.assessmentAnswer.answer : '';
            questions.assessmentAnswer.answerChoiceId = null;
          }
          questions.assessmentAnswer.applicationId = application;
          if (questions.typeCode === '4') {
            const choices = [];
            _.each(questions.questionAnswerChoice, function(choice) {
              if (choice.checked) {
                choices.push(choice.choiceText);
              }
            });
            questions.assessmentAnswer.answer = choices.join();
          }
        }
        if (questions.assessmentAnswer.answer === null) {
          questions.assessmentAnswer.answer = '';
        }
        if (questions.typeCode === '0' && questions.assessmentAnswer.answer === '') {
          questions.assessmentAnswer.answer = null;
        }
        answersList.push(questions.assessmentAnswer);
      } else {
        for (const q of questions.childQuestions) {
          getRecursively(q, application);
        }
      }
    }

    getRecursively(question, this.applicationId);
    return answersList;
  }

  dateChanged(selectedDate: Date, model) {
    model.answer = selectedDate;
  }

  getAnswersFromQuestions() {
    const that = this;
    const answersByPage = _.map(this.pagedItems, function (page) {
      const pageAnswers = [];
      if (page.questions) {
        _.each(page.questions, function (topLevelQuestion) {
          if (topLevelQuestion.question !== null) {
            const questionAnswers = that.extractAnswersFromQuestion(topLevelQuestion.question.question);
            pageAnswers.push(questionAnswers);
          }
        });
        return pageAnswers;
      } else {
        return [];
      }
    });

    const flattenedAnswers = _.flatten(_.flatten(answersByPage, true), true);
    return _.without(flattenedAnswers, null);
  }

  applyRequisition(jobId,userId,isValidateJobApply, isSubmitted) {
    this.jobService.applyRequisition(jobId, '', isValidateJobApply)
       .subscribe((response) => {
         if (response && response !== '') {
           this.authenticationService.isAppliedwithLinkedIn = false;
           if(isSubmitted)
            this.toastService.presentToast({ message: response, type: 'success' });
         }
       }, (error) => {
       });
    }

  saveAnswers(isSubmitted) {
    this.loading = true;
    const answersArray = this.getAnswersFromQuestions();
    if(!this.isAssessment){
      let resumeId = -1;
      if(this.authenticationService.isAppliedwithLinkedIn) {
        resumeId = this.resumeService.getResumeId();
      }
    this.jobService.submitRequisitionAssessmentAnswers(answersArray, this.requisitionId, resumeId, isSubmitted)
    .subscribe((response) => {
      this.loading = false;
      if(response > 0){
        this.hideActions = true;
        if(!isSubmitted)
          {
            this.toastService.presentToast({ message: this.searchTranslations.CAREER_APPLY_INCOMPLETE_SUCCESS, type: 'success' });
            this.navCtrl.push(JobDetailsPage, {"jobId": this.requisitionId, "navigatedFrom": this.navigatedFrom, "isJobSubmitted" : false});
            let currentIndex = this.navCtrl.getActive().index -1;
            this.navCtrl.remove(currentIndex);
            this.navCtrl.popTo(JobSearchComponent);
          }
      else
      {
         if (this.navigatedFrom == "CandidateProfileComponent") {
              if(this.authenticationService.isAppliedwithLinkedIn)
              this.navCtrl.setRoot(CandidateProfileComponent, {'trackRequest' : this.requisitionId});
              else
                this.navCtrl.setRoot(CandidateProfileComponent);
          }
          else if (this.navigatedFrom == "JobSearchComponent") {
          if(this.authenticationService.isAppliedwithLinkedIn)
            this.navCtrl.setRoot(JobSearchComponent, {'trackRequest' : this.requisitionId});
            else
            this.navCtrl.setRoot(JobSearchComponent);

          }
          else {
            if(this.authenticationService.isAppliedwithLinkedIn)
              this.navCtrl.setRoot(CandidateProfileComponent, {'trackRequest' : this.requisitionId});
            else
              this.navCtrl.setRoot(CandidateProfileComponent);
          }
      }
      this.applyRequisition(this.requisitionId,'',false, isSubmitted);

      }
      else {
        this.toastService.presentToast({ message: this.searchTranslations.CAREER_FAILED_MESSAGE, type: 'error' });
      }
    }, (error) => {
      this.loading = false;
      this.toastService.presentToast({ message: this.searchTranslations.CAREER_FAILED_MESSAGE, type: 'error' });
    });
  }
  else{
    this.jobService.saveRequisitionAnswers(answersArray, this.applicationId, this.assessmentId)
    .subscribe((response) => {
      this.events.publish('update-timeline-data');
      this.loading = false;
      this.navCtrl.setRoot(this.navigatedFrom);
      this.toastService.presentToast({ message: this.searchTranslations.CAREER_ASSESSMENT_SAVED, type: 'success' });
    }, (error) => {
      this.loading = false;
      this.toastService.presentToast({ message: this.searchTranslations.CAREER_FAILED_MESSAGE, type: 'error' });
    });
  }
  }

  minRatingValue: number = 0;
  maxRatingValue: number = 0;
  getMinMaxOfRatingMatrix(pagedArray){
    let minValue = 0;
    let maxValue = 0;
    _.each(pagedArray, function(page){
      if(page.questions){
        for(const question of page.questions){
          if(question.itemType == 4 && question.question.question.typeCode == 9){
            minValue = question.question.question.questionAnswerChoice[0].choiceValue;
            for(const questionAnswerChoice of question.question.question.questionAnswerChoice){
              if(questionAnswerChoice.choiceValue > maxValue)
              maxValue = questionAnswerChoice.choiceValue;
              if(questionAnswerChoice.choiceValue < minValue)
              minValue = questionAnswerChoice.choiceValue;
            }
          }
        }
      }
    });

    this.minRatingValue = minValue;
    this.maxRatingValue = maxValue;
  }

  setQuestions(response)
  {
    this.loading = false;
        this.requisitionAssessmentData = response;
        const selfAssessment = (response !== null && (!response.selfAssessments || response.selfAssessments.length === 0 ));
     if (this.requisitionAssessmentData.recruitingAssessment === 0 && selfAssessment) {
          this.saveAnswers(true);
        } else {
        if (this.requisitionAssessmentData.recruitingAssessment.items !== null) {
          for (const item of this.requisitionAssessmentData.recruitingAssessment.items) {
            if (item.itemType === 4) {
              this.setQuestionAnswers(item.question.question);
            }
          }

          var items = this.requisitionAssessmentData.recruitingAssessment.items;
          this.requisitionAssessmentData.recruitingAssessment.items = this.filterItemsBySite(items);
        }
          var selfAssessmentItems = [];

          // add self assessments to paged item array
          const selfAssessments = this.requisitionAssessmentData.selfAssessments;
          if (selfAssessments && selfAssessments.length > 0) {
            let pageNo = this.requisitionAssessmentData.recruitingAssessment.items ?
              _.maxBy(this.requisitionAssessmentData.recruitingAssessment.items, 'page').page + 1 : 1;
            for (const assessment of selfAssessments) {
              if (assessment.items.length > 0) {
                for (const item of assessment.items) {
                  item.page = pageNo;
                  item.isSelfAssessment = true;
                  if (item.itemType === 4) {
                    this.setQuestionAnswers(item.question.question);
                  }
                  selfAssessmentItems = selfAssessmentItems.concat(item);
                }
              }
              pageNo = pageNo + 1;
            }
          }

          selfAssessmentItems = this.filterItemsBySite(selfAssessmentItems);
        }
        this.arrangeItemsByPage(this.requisitionAssessmentData, this.requisitionAssessmentData.recruitingAssessment.items, selfAssessmentItems);
  }
  getSelfAssessmentForRequisition() {
    this.loading = true;
    this.jobService.getSelfAssessmentForRequisition(this.requisitionId).subscribe(
      (response) => {
       this.setQuestions(response);
      }, (error) => {
        this.loading = false;
        this.alertData = { message: this.searchTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
      }
    );
  }
  prevDateAnswer: any;
  selectTodayDate(dateAnswer) {
  this.prevDateAnswer = dateAnswer.answer;
  if(dateAnswer != null && (dateAnswer.answer == '' || dateAnswer.answer == undefined)) {
    var today = moment().format('YYYY-MM-DD');
    dateAnswer.answer = new Date(today).toISOString();
  }
  }
  removeDate(dateAnswer) {
    dateAnswer.answer = this.prevDateAnswer;
  }
  updateDateAnswer(questionanswer) {

    questionanswer.answer = new Date(questionanswer.answer).toISOString();
  }
  onCheckedOption(checked, question, questions)
  {
    if(question.isRequired)
    {
    const choices = [];
    _.each(checked, function(choice) {
      if (choice.checked) {
        choices.push(choice.choiceText);
      }
    });
    question.isValid = choices.length > 0 ? true : false;

    this.tempQuestion = question;
    this.isAllCheckboxValid = true;
    questions.forEach(element => {

      if(element.question && element.question.question.typeCode == "4"){
        if(element.question.question.id == this.tempQuestion.question.id)
          element.question.isValid = this.tempQuestion.isValid;

        if(element.question.isRequired && element.question.isValid == false)
          this.isAllCheckboxValid = false;
      }
    });
    }
  }

  prevTimeAnswer: any;
  selectCurrentTime(timeAnswer) {
    this.hourValuesFormat(timeAnswer);
    this.prevTimeAnswer = timeAnswer.assessmentAnswer.answer;
    if(timeAnswer.assessmentAnswer != null && (timeAnswer.assessmentAnswer.answer == '' || timeAnswer.assessmentAnswer.answer == undefined)) {
      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
      timeAnswer.assessmentAnswer.answer = localISOTime;
    }
  }
  private hourValuesFormat(timeAnswer) {
   if (timeAnswer.configurationCode === 2 || timeAnswer.configurationCode === 12) {
      this.hourValues = '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23';
   } else {
     this.hourValues = '0,1,2,3,4,5,6,7,8,9,10,11';
   }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/job-assessment/job-assessment.component.ts